import React from "react";
import ReactDOM from "react-dom";

import qs from "qs";
import { showErrorMessage } from "../../commons/show-error-message";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";
import EditEmployeesCsvPage from "../components/editEmployeesCsvPage/EditEmployeesCsvPage";
import { downloadEmployeesSelected } from "../download-employees-selected-csv";
import {
  getEmployees,
  getEmployeesV2,
} from "../../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { sendEmployeeBulkSession } from "../send-employees-bulk-session";

export function renderEditEmployeesCsvPage() {
  ReactDOM.render(
    <EditEmployeesCsvPage />,
    document.getElementById("page-container")
  );
}

export async function displayEditEmployeesCsvPage({ selectedEmployees } = {}) {
  try {
    if (selectedEmployees) {
      await downloadEmployeesSelected(selectedEmployees);
    } else {
      const { employees: employeesInQuery, ...query } = qs.parse(
        window.location.search.replace("?", "")
      );

      const resultantEmployees = Array.isArray(employeesInQuery)
        ? employeesInQuery
        : [employeesInQuery];

      const companyId = await findCompanyId();

      let data = [];

      if (employeesInQuery === "all") {
        const {
          data: {
            metainfo: {
              pagination: { totalItems },
            },
          },
        } = await getEmployeesV2({
          companyId,
          query: qs.stringify(query),
        });

        const res = await getEmployeesV2({
          companyId,
          query: qs.stringify({
            ...query,
            pageSize: Number(totalItems),
          }),
        });
        data = res.data.content;
      } else {
        const res = await getEmployees({
          companyId,
          params: undefined,
        });
        data = res.data;
      }

      await sendEmployeeBulkSession(
        employeesInQuery === "all"
          ? data.map(({ id }) => id)
          : resultantEmployees
      );

      await downloadEmployeesSelected(
        employeesInQuery === "all"
          ? data
          : data.filter(({ id }) =>
              resultantEmployees?.some((qId) => id === qId)
            )
      );
    }
    renderEditEmployeesCsvPage();
    addContextLog("info", "displayEditEmployeesCsvPage", "display-screen");
  } catch (e) {
    logError(e, "Error to displayEditEmployeesCsvPage");
    showErrorMessage(
      translate("edit-employees.edit-employees-upload-error"),
      true,
      e
    );
  }
}
